"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateEvent = void 0;
const uuid_1 = require("uuid");
const delta_1 = require("./delta");
class StateEvent {
    constructor(stateNode, config = {
        transitions: []
    }) {
        this.transitions = [];
        this.id = uuid_1.v4();
        this.stateNode = stateNode;
        Object.assign(this, config);
    }
    remove() {
        var _a, _b;
        const index = (_a = this.stateNode.events) === null || _a === void 0 ? void 0 : _a.indexOf(this);
        if (typeof index === 'number' && index > -1) {
            const path = this.getJsonPath();
            const oldValue = this.toJson();
            (_b = this.stateNode.events) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
            this.stateNode.workflow.history.add(new delta_1.Delta({ type: delta_1.DeltaType.Delete, path, oldValue }));
        }
    }
    updateTransitions(transitions) {
        const path = this.getJsonPath();
        const oldValue = this.toJson();
        this.transitions = transitions;
        const newValue = this.toJson();
        this.stateNode.workflow.history.add(new delta_1.Delta({ type: delta_1.DeltaType.Update, path, oldValue, newValue }));
    }
    getJsonPath() {
        var _a;
        let path = this.stateNode.getJsonPath();
        const index = (_a = this.stateNode.events) === null || _a === void 0 ? void 0 : _a.indexOf(this);
        if (index === -1) {
            throw new Error('Invalid state event. Cannot resolve event in state node.');
        }
        path += `.events[${index}]`;
        return path;
    }
    toJson() {
        return {
            name: this.name,
            description: this.description,
            isTransient: this.isTransient,
            transitions: this.transitions,
            data: this.data
        };
    }
}
exports.StateEvent = StateEvent;
//# sourceMappingURL=state-event.js.map